import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { countriesSelector, timezonesSelector, languagesSelector } from '../../app/selectors/appSelectors';
import { generalSelector, isSummaryActiveStep } from '../selectors/wizardSelectors';
import { updateStep } from '../actions/wizardActions';
import General from '../components/General/General';

const mapStateToProps = createStructuredSelector({
    editable: isSummaryActiveStep,
    formData: generalSelector,
    countries: countriesSelector,
    timezones: timezonesSelector,
    languages: languagesSelector
});

const mapDispatchToProps = { updateStep };

export default withTranslation(['common', 'validations'])(
    withRouter(
        connect(mapStateToProps, mapDispatchToProps)(General)
    )
);
